import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { Resource } from 'model/Resource';
import { addAsyncCasesNew, addTakeLatestResourceFactory } from 'shared/utils/redux';

import { LinkResetDigestState, STORE_NAME } from './initialState';
import {
  fetchDigestEmailPreference,
  fetchLinkResetDigest,
  saveDigestEmailPreference,
} from './asyncActions';

const addTakeLatestResource = addTakeLatestResourceFactory<LinkResetDigestState.Domain>();

export const linkResetDigestSlice = createSlice({
  name: STORE_NAME,
  initialState: LinkResetDigestState.INITIAL_DOMAIN,
  reducers: {
    // The stored digest is unfiltered - the screen narrows it per programme at render time. Drop it
    // on unmount rather than let the next programme paint the previous one's rows.
    clearLinkResetDigest: (state) => {
      state.digest = LinkResetDigestState.INITIAL_DOMAIN.digest;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<LinkResetDigestState.Domain>) => {
    // Take-latest, not plain async cases: a slow answer for the previous date must not overwrite
    // the answer for the date the admin is actually looking at.
    addTakeLatestResource(builder, fetchLinkResetDigest, 'digest');

    addAsyncCasesNew(builder, fetchDigestEmailPreference, (state, action) => {
      state.emailPreference = action.payload;
    });

    // Only the fulfilled case: a save must not drop the preference back to a pending
    // resource, or the toggle would unmount on every flip. A failed save leaves the stored
    // value untouched and the form resets itself to it.
    builder.addCase(saveDigestEmailPreference.fulfilled, (state, action) => {
      state.emailPreference = Resource.createResolvedResource({ data: action.payload });
    });
  },
});

export const { clearLinkResetDigest } = linkResetDigestSlice.actions;
